<div class="card">
  <div class="card-body">
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex flex-column">
        <p class="h4 m-0">Ingressos do Tipo Individual</p>
        @if (isFreeEvent) {
          <p class="p text-secondary">
            Crie o ingresso gratuito do evento. O valor é fixo em R$ 0,00 e apenas 1 tipo de ingresso é permitido.
          </p>
        } @else {
          <p class="p text-secondary">Configure ingressos e visualize suas opções criadas na tabela abaixo.</p>
        }
      </div>
    </div>
    <app-ticket-table
      [ticketBatches]="ticketBatches"
      [management]="!!eventId"
      [transitionDisabledReason]="transitionDisabledReason"
      [singleTicketMode]="isFreeEvent"
      (batchesTransitioned)="batchesTransitioned.emit($event)"
      (ticketBatchesChange)="ticketBatchesChange.emit($event)"
      (createBatchClick)="openBatchModal()"
      (editBatchClick)="openBatchModal($event)"
      (editTicketClick)="handleOpenModalTickets($event)"
      (createTicketClick)="handleOpenModalTickets($event)"
      (createSingleTicketClick)="handleCreateSingleTicket()"
      (editAvailabilityClick)="editSingleAvailability()" />
  </div>
</div>
